export const FETCH_CURRENCIES = 'CURRENCIES/FETCH'
export const FETCH_SUCCESS_CURRENCIES = 'CURRENCIES/FETCH_SUCCESS'
export const FETCH_ERROR_CURRENCIES = 'CURRENCIES/FETCH_ERROR'
